import { Action } from '@ngrx/store';

export enum SuccessModalActionTypes {
  CloseSuccessModal = '[SuccessModal] Close',
}

export class CloseSuccessModal implements Action {
  readonly type = SuccessModalActionTypes.CloseSuccessModal;
}

export type SuccessModalActions = CloseSuccessModal;
